import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Missing reset token");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <div className="flex justify-center mb-8"><Logo /></div>
      <div className="border border-slate-200 rounded-2xl bg-white p-8">
        <h1 className="font-display text-2xl font-bold text-slate-900">Reset password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="password">New password</Label>
            <Input id="password" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" className="mt-1.5" />
          </div>
          <Button type="submit" disabled={busy} data-testid="reset-submit-btn" className="w-full pill-btn bg-[#1E3A8A] hover:bg-[#1E40AF] text-white h-11">
            {busy ? "Updating…" : "Update password"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-slate-600 text-center">
          <Link to="/login" className="text-[#1E3A8A] font-semibold hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
